import axios from 'axios';
import { CUSTOMER_DETAILS_DEFAULT } from './GlobalParams';

// const urlPrefix = process.env.REACT_APP_URL_PREFIX
// const publicUrl = process.env.PUBLIC_URL
// const URLProductsSalesForce = `${api_host}/getProducts`;

const api_host = process.env.REACT_APP_API_HOST || "https://api.mahuti.co.il";

const URLProductsSalesForce = `${api_host}/getLp`;
const URLgetDatesSalesForce = `${api_host}/getDates`;

const URLgetUpsaleSalesForce = `${api_host}/getUpsale`;
const URLgetHoursSalesForce = `${api_host}/getHours`;
const URLGetCampainsSalesForce = `${api_host}/getCampaigns`;
const URLGetCouponSalesForce = `${api_host}/patchOpportunity`
const URLGetTicketsSalesForce = `${api_host}/getTickets`
const URLGetAmountSalesForce = `${api_host}/getAmount`
const URLsetOportunitySalesForce = `${api_host}/setOpportunity`
const URLaddActivitySalesForce = `${api_host}/addActivity`
const URLeditActivitySalesForce = `${api_host}/editActivity`
const URLdeleteActivitySalesForce = `${api_host}/deleteActivity`


axios.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(null, (err) => {
    let config = err.config;
    config.retryCount = config.retryCount ? config.retryCount : 0;
    config.retryDelay = 1000;
    config.retryTimes = config.retryTimes ? config.retryTimes : 3;
    
    if (!config || !config.retryTimes) return Promise.reject(err);

    if (config.retryCount >= config.retryTimes) {
      return Promise.reject(err);
    }
    // Increase the number of retries
    config.retryCount=config.retryCount+1;
    const delay = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay);
    });
    // Resend
    return delay.then(function () {
      return axios(config);
    });
  });


export const apiCallPlus = (sfCall, options = {}, retry) => {
    sfCall().then(res => {
        if(res.status === 'OK') return res.data
        if(retry > 0) apiCallPlus(sfCall,options, retry - 1);
    })
}

export const getProductsSF = (landingPageName = false) => {
    let landingPagePathAddition = (landingPageName && landingPageName != 'parents_and_kids_2') ? `?uri=${landingPageName}` : '/'
    return axios.get(URLProductsSalesForce + landingPagePathAddition)
}

export const getTicketsSF = (activityDate, productId) => {
    return axios.get(URLGetTicketsSalesForce, {
        params: {
            date: activityDate,
            productId: productId
        }
    });
}

export const patchOpportunitySF = (copounID, opportunityId, stage, customerDetails, isInternal) => {
    return axios.post(URLGetCouponSalesForce, {
        coupon: copounID,
        opportunityId: opportunityId,
        stage: stage,
        customerDetails: {        
            firstName: customerDetails.firstName,
            lastName : customerDetails.lastName,
            email : customerDetails.email,
            mobilePhone: customerDetails.phoneNumber,
            internal: isInternal
        },
    })
}

export const getCampainsSF = (date, tickets, productId) => {
    const ticketsCount = tickets ? (tickets.adults || 0) + (tickets.underAge || 0) : 0

    const requestOptions = {
        method: 'get',
        url: URLGetCampainsSalesForce,
        params: {
            date: date,
            tickets: ticketsCount
        },
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        redirect: 'follow'
    };

    return axios(requestOptions);



}

export const getDatesSF = (tickets, productId) => {


    var config = {
        method: 'GET',
        url: URLgetDatesSalesForce,
        params: {
            tickets: tickets,
            productId: productId
        }
    };

    return axios(config)

    // return axios(`${URLgetDatesSalesForce}`, {'tickets': tickets});
}

export const getUpsaleSF = (store) => {

    const reqJson = {
        params: {
            productId: store.selectedActivity.Id,
            date: store.activityDate,
            startTime: store.selectedActivity.timing?.startTime,
            endTime: store.selectedActivity.timing?.endTime
        }
    }

    return axios.get(`${URLgetUpsaleSalesForce}`, reqJson)

}

export const getHoursSF = (product) => {
    const tickets = product && product.visitors ? (product.visitors.adults || 0) + (product.visitors.underAge || 0) : 0;
    return axios.get(URLgetHoursSalesForce, {
        params: {
            productId: product.selectedActivity?.productId,
            date: product.activityDate,
            tickets: tickets
        }
    })
}

export const getAmount = (opportunityId) => {
    return axios.get(URLGetAmountSalesForce, {
        params: {
            opportunityId: opportunityId
        }
    })
}


export const setOportunity = (selectedActivities, customerDetails) => {

    return axios.post(URLsetOportunitySalesForce, {
        selectedActivities: selectedActivities,
    })
}

export const addActivity = (selectedActivity, opportunityId) => {
    return axios.post(URLaddActivitySalesForce, {
        selectedActivities: selectedActivity,
        opportunityId: opportunityId
    })
}

export const editActivity = (selectedActivity, opportunityProduct, opportunityId) => {

    return axios.post(URLeditActivitySalesForce, {
        selectedActivities: selectedActivity,
        opportunityProduct: opportunityProduct,
        opportunityId: opportunityId
    })
}

export const deleteActivity = (opportunityProduct, opportunityId) => {

    return axios.delete(URLdeleteActivitySalesForce, {
        data: {
            opportunityProduct: opportunityProduct,
            opportunityId: opportunityId
        }
    })
}

export const onPaymentSuccess = () => {

}

export const createframe = () => {
    var newFrame = document.createElement("frame");
    newFrame.id = "myNewFrame";
    newFrame.name = "myNewFrame";

}